import { ihm_viewer__dictionary, locale } from 'Application/i18n/i18nViewer'

/**
 * Component Measures specification for desktop
 * @params {object} - react props
 * @returns {JSX}
 */
export const MeasuresDesktop = props => {

    const
        {
            getmeta,
            getKorkhausValues,
            getNumeric,
            teeth,
            mainMeasures,
            excess,
            korkhaus,
            biteJump,
            biteJumpValues,
            renderBiteJump,
        } = props

    return (
        <section className="specsDesktop measures">
            <table id='globalMeasureTable'>
                <tbody>
                    <tr>
                            <>
                                <td className='speMeasures'>
                                    <h3>
                                        {ihm_viewer__dictionary.SPE_MEASURES_ITEMS.ARCH_WIDTH[locale()]}
                                    </h3>
                                    {Object.entries(teeth).map( ( [jaw, jawSpecs] ) =>
                                        Object.entries(jawSpecs).map( ( [side, sideSpecs]) =>
                                            <div className='speMeasure' key={'side'+side}>
                                                <table>
                                                    <tbody>
                                                        {
                                                            sideSpecs.teeth.map( tooth => {
                                                                let info = getmeta('toothID_'+tooth, jaw, 'toothWidths')
                                                                return ( info ) ?
                                                                    <tr key={'width'+tooth+'line'}>
                                                                        <td key={'width'+tooth+'name'}>
                                                                            [ {tooth} ]
                                                                        </td>
                                                                        <td key={'width'+tooth+'value'}>
                                                                            { getNumeric( info ) }
                                                                        </td>
                                                                    </tr> :
                                                                    null
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                                {
                                                    <div className='sumMeasure' key={'sumMeasure'+jaw}>
                                                        {
                                                            ( side === 'right' )?
                                                            ihm_viewer__dictionary.SPE_MEASURES_ITEMS.SUM33[locale()]+': ' + getNumeric( getmeta( 'sum33', jaw ) ) :
                                                            ihm_viewer__dictionary.SPE_MEASURES_ITEMS.SUM66[locale()]+': ' + getNumeric( getmeta( 'sum66', jaw ) )
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        )
                                    )}
                                </td>
                                <td className='speMeasures'>
                                    <h3>{ihm_viewer__dictionary.SPE_MEASURES_ITEMS.MAIN_MEASURES[locale()]}</h3>
                                    <div className='speMeasure'>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>{ihm_viewer__dictionary.SPE_MEASURES_ITEMS.UPPER[locale()]}</th>
                                                    <th>{ihm_viewer__dictionary.SPE_MEASURES_ITEMS.LOWER[locale()]}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                mainMeasures.map ( spec =>
                                                        <tr key={'mainMeasure'+spec}>
                                                            <td  key={'mainMeasure'+spec+'title'}>
                                                                {ihm_viewer__dictionary.SPE_MEASURES_ITEMS[spec.toUpperCase()][locale()]}
                                                            </td>
                                                            {
                                                                Object.keys(teeth).map( jaw =>
                                                                    <td key={'mainMeasure'+spec+jaw}>
                                                                        { getNumeric( getmeta(spec, jaw, 'mainMeasures') ) }
                                                                    </td>
                                                                )
                                                            }
                                                        </tr>
                                                )
                                            }
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </>
                            <>
                                <td className='measureTable'>
                                    <h3>{ihm_viewer__dictionary.SPE_MEASURES_ITEMS.BOLTON_ANALYSIS[locale()]}</h3>
                                    <div className='boltonTable'>
                                        <table>
                                            <thead className='tableHead'>
                                                <tr>
                                                    <th></th>
                                                    <th>{ihm_viewer__dictionary.SPE_MEASURES_ITEMS.VALUE[locale()]}</th>
                                                    <th>{ihm_viewer__dictionary.SPE_MEASURES_ITEMS.RATIO[locale()]}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                excess.map( exces => {
                                                    return <tr key={'Excess'+exces+'line'}>
                                                        <td key={'Excess'+exces+'title'}>
                                                            {ihm_viewer__dictionary.SPE_MEASURES_ITEMS[exces.toUpperCase()][locale()]}
                                                        </td>
                                                        <td key={'Excess'+exces+'value'}>
                                                            { getNumeric( getmeta( exces+'Val' ) ) }
                                                        </td>
                                                        <td key={'Excess'+exces+'ratio'}>
                                                            { getNumeric( getmeta( exces+'Ratio' ) ) }
                                                        </td>
                                                    </tr>
                                                }
                                            )}
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                                <td className='speMeasures'>
                                    <h3>
                                        {ihm_viewer__dictionary.SPE_MEASURES_ITEMS.KORKHAUS_ANALYSIS[locale()]}
                                    </h3>
                                    <div className='speMeasure'>
                                        <table>
                                            <thead>
                                            {
                                                <tr>
                                                <th></th>
                                                {
                                                    Object.keys( teeth ).map( jaw =>
                                                        korkhaus.map ( h =>
                                                        <th key={'Korkhaus'+jaw+'title'+h}>
                                                            {
                                                                (h !== '')?
                                                                ihm_viewer__dictionary.SPE_MEASURES_ITEMS[( h === 'measure' )? jaw.charAt(1).toUpperCase()+'_MEASURES': h.toUpperCase()][locale()]:
                                                                null
                                                            }
                                                        </th>
                                                        )
                                                    )
                                                }
                                                </tr>
                                            }
                                            </thead>
                                            <tbody>
                                            {
                                                Object.values(getKorkhausValues()).map( field =>
                                                <tr key={'Korkhaus'+field+'line'}>
                                                    <td key={'Korkhaus'+field+'title'}>
                                                        {ihm_viewer__dictionary.SPE_MEASURES_ITEMS[field[0]][locale()]}
                                                    </td>
                                                    {
                                                        Object.keys( teeth ).map( jaw => korkhaus.map ( h =>
                                                                <td key={'Korkhaus'+jaw+h+'value'}>
                                                                    {
                                                                        ( h !== '')?
                                                                            getmeta( field[0], jaw, 'korkhaus') ?
                                                                                getNumeric( getmeta( field[0], jaw, 'korkhaus')[h] ):
                                                                                '-':
                                                                            null
                                                                    }
                                                                </td>
                                                            )
                                                        )
                                                    }
                                                </tr>
                                                )
                                            }
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                                {renderBiteJump && (
                                <td className='measureTable'>
                                    <h3>
                                        {ihm_viewer__dictionary.SPE_BITEJUMP[locale()]}
                                    </h3>
                                    <div className='biteJumpTable'>
                                        <table>
                                            <thead className="tableHead" >
                                            <tr>
                                                <th></th>
                                                <th>{ihm_viewer__dictionary.SECTION_MEASURES[locale()]}</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {biteJump.map((nom, i) => (
                                                <tr key={'bitejumpRow'+i}>
                                                    <td>{nom}</td>
                                                    <td>{(i === 1 ? -biteJumpValues[i] : biteJumpValues[i]).toFixed(1)}</td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </td>)}
                            </>
                    </tr>
                </tbody>
            </table>
        </section>
    )
}
